<script>
  import {
    selectedProcedures,
    step,
  } from '../../../../../../../../store/common';

  const onClickCart = () => {
    if ($selectedProcedures.length) {
      step.set(3);
    }
  };
</script>

<!--DEFAULT STATE-->
<div class="uk-flex uk-margin-bottom uk-flex-middle uk-flex-between">
  <h3 class="uk-h4 uk-margin-remove">Select the body area</h3>
  <a
    class={`uk-icon-button uk-flex-row-reverse ${
      $selectedProcedures.length ? 'uk-button-primary' : 'uk-disabled'
    }`}
    style="width: 80px"
    data-uk-icon="cart"
    on:click={onClickCart}
  >
    <span class="uk-text-small uk-margin-small-left">
      ({$selectedProcedures.length})
    </span>
  </a>
</div>
<p class="uk-text-muted uk-text-small">
  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aperiam dignissimos
  dolorem dolores esse illo illum ipsa, nobis repellendus. Assumenda
  consectetur, doloribus facilis fugiat ipsum quo. Amet blanditiis cumque fugit
  suscipit.
</p>
<!--end of DEFAULT STATE-->
